import React from 'react';
import { CprIcon } from 'canopy-styleguide!sofe';
import { SearchResultItem } from './search-result-item.component';

import styles from './nav-search.styles.css';

export const SearchResults = ({ list, categories, ...props }) => {
  const noResults = () => (
    <div className={`cps-margin-top-8`} style={{ fontStyle: 'italic' }}>
      No Results
    </div>
  );

  return (
    <div tabIndex={-1} className={styles.searchResults}>
      {categories && categories.length > 0 ? (
        categories.map(category => {
          const listByCategory = list.filter(item => item.field === category.key);
          return (
            <div key={category.id} className="cps-margin-top-8 cps-margin-bottom-8">
              <div className={styles.category}>
                <CprIcon name={category.icon} className="cps-margin-right-8" />
                <span className="cps-wt-semibold">{category.title}</span>
              </div>
              {listByCategory.length > 0 ? (
                <ul className={styles.searchList}>
                  {listByCategory.map(item => (
                    <SearchResultItem item={item} category={category} {...props} key={`${item.id}-${item.value}`}/>
                  ))}
                </ul>
              ) : (
                noResults()
              )}
            </div>
          );
        })
      ) : list.length > 0 ? (
        <ul className={styles.searchList}>
          {list.map(item => (
            <SearchResultItem item={item} key={`${item.id}-${item.value}`}/>
          ))}
        </ul>
      ) : (
        noResults()
      )}
    </div>
  );
};
